import React from "react";
import FontAwesome from "react-fontawesome";
import autoBind from "react-autobind";
import _ from "lodash";

import { markdownToHtml } from "../../utils/markupUtils";
import { getUrlForValue } from "../../actions/drive";
import { getSelectedActivityId } from "../../actions/playerActions";
import PlayerRadio from "./PlayerRadio";
import withPlayerItemHoc from "./PlayerItemHoc";
import DoneButton from "./DoneButton";
class PlayerSingleChoice extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;

		autoBind(this);
		this.state = {
		}
	}

	render() {
		if (this.props.showMode !== true) {
			if (this.props.readOnly) {
				return this.renderReadOnly();
			} else {
				return this.renderEditable();
			}
		} else {
			return this.renderShowMode();
		}
	}

	onClick(value, choiceItem) {
		this.setState({
			choiceItem: choiceItem
		});
		if (this.props.onChange) { this.props.onChange(value, choiceItem); }
	}

	onSubmit() {
		if (this.props.onSubmit) { this.props.onSubmit(this.props.item.value, this.state.choiceItem); }
	}



	renderReadOnly() {
		const { item, getImage, getVideo, getPdf } = this.props;

		let idPostfix = this.props.getActivityItemPath("-");
		const rows = item.choiceItems.map((choiceItem, i) => {

			//add dynamic styles if present
			if (choiceItem.properties && choiceItem.properties !== "") {
				let properties = choiceItem.properties;

				let propertiesObject = JSON.parse(properties);
				Object.assign(choiceItem, propertiesObject);

				
			}
			let inputSize = "24px";
			if (choiceItem.style) {
				choiceItem.style.justifyContent = choiceItem.style.textAlign === "right" ? "flex-end" : "flex-start";
				inputSize = choiceItem.style.inputSize ? choiceItem.style.inputSize : 24;
			}

			let radio;
			if (item.value === choiceItem.value) {
				radio = <FontAwesome fixedWidth={true} style={{ fontSize: inputSize, margin: 10 }} name="dot-circle-o" />;
			} else {
				radio = <FontAwesome fixedWidth={true} style={{ fontSize: inputSize, margin: 10 }} name="circle-o" />;
			}

			let idKey = "player-radio-item-" + i + "-" + idPostfix;
			let style = { display: "flex", flexDirection: "row", width: "100%", alignItems: "center" };

			return (<div key={idKey} style={_.assign({},style, choiceItem.style)}>
				{radio}
				<div>{choiceItem.label}</div>
			</div>);
		});

		let rowsContainer;

		if (item.backgroundImage) {
			rowsContainer = <div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center" }}>
				<div style={{ backgroundImage: `url(${item.backgroundImage})` }} className="player-item-background-image">
					{rows}
				</div>
			</div>;

		} else {
			rowsContainer = <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
				{rows}
			</div>
		}

		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		return (
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%", overflowX: "none" }}>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { readOnlyLinks: true })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { readOnlyLinks: true })} />
					{getImage()}
					{getVideo()}
					{getPdf()}
					{rowsContainer}
				</div>
			</div>
		);
	}

	renderEditable() {
		const self = this;

		const { item, getImage, getVideo, getPdf, disabled, listIndex, sectionIndex, itemIndex } = this.props;

		let idPostfix = this.props.getActivityItemPath("-");

		let rows = item.choiceItems.map((choiceItem, idx) => {
			const idKey = "player-radio-item-" + idx + "-" + idPostfix;

			//add dynamic styles if present
			if (choiceItem.properties && choiceItem.properties !== "") {
				let properties = choiceItem.properties;

				let propertiesObject = JSON.parse(properties);
				Object.assign(choiceItem, propertiesObject);

			}

			let inputSize = 30; // use default
			if (choiceItem.style) {
				choiceItem.style.justifyContent = choiceItem.style.textAlign === "right" ? "flex-end" : "flex-start";
				inputSize = choiceItem.style.inputSize ? choiceItem.style.inputSize : 30;
			}
			return <PlayerRadio size={inputSize} disabled={disabled} className="player-item-radio" key={idKey} id={idKey} checked={item.value === choiceItem.value} onClick={(e) => { self.onClick(e.target.value, choiceItem) }} value={choiceItem.value} label={choiceItem.label} style={choiceItem.style} />;
		});


		let rowsContainer;

		if (item.backgroundImage) {
			rowsContainer = <div style={{ display: "flex", flexDirection: "column", width: "100%", marginBottom: "12px", alignItems: "center" }}>
				<div style={{ backgroundImage: `url(${item.backgroundImage})` }} className="player-item-background-image">
					{rows}
				</div>
			</div>;

		} else {
			rowsContainer = <div style={{ display: "flex", flexDirection: "column", width: "100%", marginBottom: "12px" }}>
				{rows}
			</div>
		}
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		return (
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%", overflowX: "none" }}>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
					{getImage()}
					{getVideo()}
					{getPdf()}
					{rowsContainer}
					{!disabled && <DoneButton onSubmit={this.onSubmit} />}
				</div>
			</div>
		);
	}

	renderShowMode() {
		const self = this;

		const { item, disabled, showModeTextAlign: _showModeTextAlign } = this.props;

		// console.log("Deternine background image", this.props);
		let backgroundImage;
		if (item.backgroundImage) {
			const url = getUrlForValue(item.backgroundImage, getSelectedActivityId());
			backgroundImage = `url(${url})`;
		}

		let mediaItem;

		let image = this.props.getImageShowMode();
		let video = this.props.getVideoShowMode(this.showModeVideoRef);

		if (image) {
			mediaItem = image;
		} else if (video) {
			mediaItem = video;
		}

		const hasTextContent = (item.label1 && !_.isEmpty(item.label1)) || (item.label2 && !_.isEmpty(item.label2))

		const { showModeTextAlign } = item;

		let align = "";
		if (showModeTextAlign || _showModeTextAlign) {
			const targetShowModeTextAlign = showModeTextAlign ? showModeTextAlign : _showModeTextAlign;
			align = " " + targetShowModeTextAlign.split("-").join(" ");
		}


		let idPostfix = this.props.getActivityItemPath("-");

		let rows = item.choiceItems.map((choiceItem, idx) => {
			const idKey = "player-radio-item-" + idx + "-" + idPostfix;

			//add dynamic styles if present
			if (choiceItem.properties && choiceItem.properties !== "") {
				let properties = choiceItem.properties;

				let propertiesObject = JSON.parse(properties);
				Object.assign(choiceItem, propertiesObject);

			}

			let inputSize = 30; // use default
			if (choiceItem.style) {
				choiceItem.style.justifyContent = choiceItem.style.textAlign === "right" ? "flex-end" : "flex-start";
				inputSize = choiceItem.style.inputSize ? choiceItem.style.inputSize : 30;
			} else {
				choiceItem.style = {};
			}

			//should have default theme specific to show mode
			if (_.isUndefined(choiceItem.style.fontSize)) {
				choiceItem.style.fontSize = "18px";
			}

			if (_.isUndefined(choiceItem.style.color)) {
				choiceItem.style.color = "#FFFFFF";
			}

			if (_.isUndefined(choiceItem.style.textAlign)) {
				choiceItem.style.textAlign = "left";
			}
			
			return <PlayerRadio size={inputSize} disabled={disabled} className="player-item-radio" key={idKey} id={idKey} checked={item.value === choiceItem.value} onClick={(e) => { self.onClick(e.target.value, choiceItem) }} value={choiceItem.value} label={choiceItem.label} style={choiceItem.style} />;
		});


		let rowsContainer = <div style={{ display: "flex", flexDirection: "column", marginBottom: "12px", marginTop: "12px" }}>
			{rows}
		</div>
		
		return (<div style={{
			display: "flex", flexDirection: "column", width: "100%", height: "100%", backgroundImage: backgroundImage, backgroundPosition: "center", backgroundSize: "cover", backgroundRepeat: "noRepeat"
		}}>
			<div style={{ display: "flex", width: "100%", height: "100%", padding: "20px 50px 40px 50px", boxSizing: "border-box" }}>
				<div className="player-show-mode-view" style={{ width: "100%", height: "100%", overflow: "none", display: "flex", position: "relative" }}>

					{hasTextContent && <div className={`player-show-mode-label-item-container${align}`}>
						<h2 dangerouslySetInnerHTML={markdownToHtml(item.label1)} />
						<h3 dangerouslySetInnerHTML={markdownToHtml(item.label2)} />
						{rowsContainer}
					</div>}
					{mediaItem && <div className="player-show-mode-media-item-container">
						<div>{mediaItem}</div>
					</div>}
				</div>
			</div>
		</div>);
	}
}

export default withPlayerItemHoc(PlayerSingleChoice);